<template>
  <b-container fluid>
    <h1>COVID Observations</h1>
    <div v-if="loaded">
      <mio-filters label="Select country:" :options="covidObservationsData.filters" />
      <mio-output
        :messages="covidObservationsData.messages"
        :tables="covidObservationsData.tables"
        :method="covidObservationsData.method"
      />
    </div>
    <h2 v-else>Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import { set, get, validateRow } from '@/utils/MioHelpers';
import MioFilters from '@/components/MioFilters';
import MioOutput from '@/components/MioOutput';

export default {
  name: 'MioCovidObservations',
  components: {
    MioFilters,
    MioOutput,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      GET_COVID_OBS_SMALL: "mio/GET_COVID_OBS_SMALL",
    }),
    async getData() {
      try {
        await this.GET_COVID_OBS_SMALL();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    covidObservationsData: {
      get() {
        let working = this.$store.state.mio.covidObsSmall;
        let output = {
          method: "Positive indicators are shown as a percentage of total observations per month per country.",
          messages: [],
        };

        let cols = {
          supplied_soap: "Soap Present",
          hand_washing: "Hand Washing",
          masks_teacher: "Teachers Using Masks",
          masks_student: "Students Using Masks",
          social_distancing: "Social Distancing",
          individuals_infected: "Indication of Infected Individuals",
          parent_covid_workshops_delivered: "Parent COVID Workshops Delivered",
        };
        let colKeys = [...Object.keys(cols)];

        // Output
        output.tables = Object.keys(working).sort().map(country => ({
          title: country,
          cols: cols,
          rows: Object.keys(working[country]).sort().reverse().map(month => ({
            title: `${month}<br><small><em>${working[country][month].total} observations</em></small>`,
            subRows: ['percentage', 'number'].map(metric => ({
              class: (metric === 'number') ? 'small' : 'font-weight-bold',
              data: (metric === 'number')
                ? Object.keys(cols).map(col => working[country][month].data[col] || '0')
                : Object.keys(cols).map(col => ((100 * (working[country][month].data[col] || 0) / working[country][month].total).toFixed(0) + '%')),
            })),
          })),
        }));

        // Add country filters
        output.filters = Object.keys(working).sort();

        // console.log(working);
        // console.log(output);
        return output;
      },
    },
  },
};
</script>
